import React from 'react';
import {
    Document20Regular,
    Mail20Regular,
    Video20Regular,
    Folder20Regular,
    ChevronDown16Regular,
    ChevronRight16Regular,
} from '@fluentui/react-icons';
import styles from '../css/vdr.module.css';
const VDRSidebar = ({
    activeView,
    analyticsContext = { type: 'project' },
    onSelectView,
    workstreams = [],
    folders = [],
    expandedWorkstreamId,
    selectedWorkstreamId,
    selectedFolderId,
    onSelectWorkstream,
    onSelectFolder,
    onAddWorkstream,
    fileCountsByFolder = {},
    fileCountsByWorkstream = {},
    initialDocsCount = 0,
    mailCount = 0,
    recordingsCount = 0,
    showMail = true,
    showRecordings = true,
    collapsed,
    onToggleCollapse,
}) => {
    const onAnalytics = activeView === 'analytics';

    if (collapsed) {
        return (
            <aside className={styles.sidebar} style={{ width: 48 }}>
                <div className={styles.sidebarCollapse}>
                    <button type="button" className={styles.iconBtn} onClick={onToggleCollapse} aria-label="Expand sidebar">
                        →
                    </button>
                </div>
            </aside>
        );
    }

    return (
        <aside className={styles.sidebar}>
            <div className={styles.sidebarCollapse}>
                <button type="button" className={styles.iconBtn} onClick={onToggleCollapse} aria-label="Collapse sidebar">
                    ←
                </button>
            </div>

            <p className={styles.sectionLabel}>Project Sources</p>
            <button
                type="button"
                className={`${styles.navItem} ${activeView === 'initial' || (onAnalytics && analyticsContext.type === 'initial') ? styles.navItemActive : ''}`}
                onClick={() => onSelectView('initial')}
            >
                <Document20Regular />
                <span className={styles.navItemLabel}>Initial Project Documents</span>
                <span className={styles.navCount}>{initialDocsCount}</span>
            </button>
            {showMail ? (
                <button
                    type="button"
                    className={`${styles.navItem} ${activeView === 'mail' ? styles.navItemActive : ''}`}
                    onClick={() => onSelectView('mail')}
                >
                    <Mail20Regular />
                    <span className={styles.navItemLabel}>Project Mail</span>
                    <span className={styles.navCount}>{mailCount}</span>
                </button>
            ) : null}
            {showRecordings ? (
                <button
                    type="button"
                    className={`${styles.navItem} ${activeView === 'recordings' ? styles.navItemActive : ''}`}
                    onClick={() => onSelectView('recordings')}
                >
                    <Video20Regular />
                    <span className={styles.navItemLabel}>Meeting Recordings</span>
                    <span className={styles.navCount}>{recordingsCount}</span>
                </button>
            ) : null}

            <p className={styles.sectionLabel}>Workstreams</p>
            {(workstreams || []).map(ws => {
                const expanded = expandedWorkstreamId === ws.id;
                const count = fileCountsByWorkstream[ws.id] ?? 0;
                return (
                    <div key={ws.id}>
                        <button
                            type="button"
                            className={`${styles.navItem} ${
                                (!onAnalytics && activeView === 'workstream' && selectedWorkstreamId === ws.id && !selectedFolderId) ||
                                (onAnalytics &&
                                    analyticsContext.type === 'workstream' &&
                                    String(analyticsContext.workstreamId) === String(ws.id))
                                    ? styles.navItemActive
                                    : ''
                            }`}
                            onClick={() => onSelectWorkstream(ws)}
                        >
                            {expanded ? <ChevronDown16Regular /> : <ChevronRight16Regular />}
                            <span className={styles.navItemLabel}>{ws.name}</span>
                            <span className={styles.navCount}>{count}</span>
                        </button>
                        {expanded &&
                            (folders || [])
                                .filter(folder => !folder.parent && !folder.parent_id)
                                .map(folder => (
                                <button
                                    key={folder.id}
                                    type="button"
                                    className={`${styles.folderNav} ${
                                        (!onAnalytics && selectedFolderId === folder.id) ||
                                        (onAnalytics &&
                                            analyticsContext.type === 'folder' &&
                                            String(analyticsContext.folderId) === String(folder.id))
                                            ? styles.folderNavActive
                                            : ''
                                    }`}
                                    onClick={() => onSelectFolder(ws, folder)}
                                >
                                    <Folder20Regular />
                                    <span className={styles.navItemLabel}>{folder.name}</span>
                                    <span className={styles.navCount}>{fileCountsByFolder[folder.id] ?? 0}</span>
                                </button>
                            ))}
                    </div>
                );
            })}

            <button type="button" className={styles.addWsBtn} onClick={onAddWorkstream}>
                + Add workstream
            </button>
        </aside>
    );
};

export default VDRSidebar;
